export class CreateTrillionUserDataDto {  
  readonly email: string
  readonly url: string

  constructor(email: string, url: string) {
    this.email = email
    this.url = url
  }
}
